export default __webpack_public_path__ + "static/media/analytics-sample.c3f38eb4.png";